// extracted by mini-css-extract-plugin
export var callCard = "_ls-0";
export var callMessageButton = "_ls-1";
export var helpIcon = "_ls-3";
export var helpIconContainer = "_ls-4";
export var verticalDivider = "_ls-2";